// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__GubDf","validationTips":"StatementDescriptor_validationTips__3byOt"};